module.exports = __webpack_public_path__ + "img/11.701e1c0.webp";